module.exports = __webpack_public_path__ + "img/financial_express.3455ff39.png";